import { Component, Input, OnInit } from '@angular/core';
import { PolicySummary } from '../../models/common-data-types';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CardModule } from 'primeng/card';
import { FileUploadModule } from 'primeng/fileupload';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../service/language.service';
import { ScreenSizeService } from '../../service/screen-size.service';
import { InsuredVehicleCardComponent } from '../common/insured-vehicle-card/insured-vehicle-card.component';

@Component({
    selector: 'app-policy-summary',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        CardModule,
        FileUploadModule,
        CalendarModule,
        InputTextModule,
        FormsModule,
        TableModule,
        DividerModule,
        TranslateModule,
        ReactiveFormsModule,
        InsuredVehicleCardComponent,
    ],
    templateUrl: './policy-summary.component.html',
    styleUrl: './policy-summary.component.scss',
})
export class PolicySummaryComponent implements OnInit {
    @Input()
    policy!: PolicySummary;

    selectedLanguage: any = null;

    constructor(
        private translate: TranslateService,
        private languageService: LanguageService,
        private screenSizeService: ScreenSizeService
    ) {}

    ngOnInit(): void {
        this.initializeLocale();
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translate.use(language);
        this.languageService.setLanguage(language);
    }

    getPolicyHeader(): string {
        return this.policy.coverMetadata.displayName;
    }

    getDeviceType() {
        return this.screenSizeService.getDeviceType();
    }
}
